<template lang="html">
  <div class="ph1 dib">
    <div class="f7 tracked b mb1">
      {{ label }}
    </div>
    <div class="f4 font-futura-bold ttu">
      {{ detail }}
    </div>
  </div>
</template>

<script>

export default {
  props: ['detail', 'label'],
  components: {
  },
  computed: {

  },
  methods: {
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanList/FloorplanInfo.vue